import { defineMessages } from 'react-intl';

export const messages: {
	starPopupAutoUpgradeTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupDirectTrialTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupDisclaimerWithoutPaymentDetails: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupDisclaimerWithoutPaymentDetailsNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupDisclaimerWithPaymentDetails: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupDisclaimerWithPaymentDetailsNoDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupEndUserDisclaimerWithoutPaymentDetails: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupEndUserDisclaimerWithPaymentDetails: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupManualTrialTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupPrimaryButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	starPopupSecondaryButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	starPopupAutoUpgradeTitle: {
		id: 'edition-benefits-modal.edition-benefits-popup.auto-upgrade.title',
		defaultMessage:
			"You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
		description: 'Edition awareness button popup title',
	},
	starPopupManualTrialTitle: {
		id: 'edition-benefits-modal.edition-benefits-popup.manual-trial.title',
		defaultMessage:
			'Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started',
		description: 'Edition awareness button popup title',
	},
	starPopupDirectTrialTitle: {
		id: 'edition-benefits-modal.edition-benefits-popup.direct-trial.title',
		defaultMessage: "You're on a free trial of our {edition} plan",
		description: 'Edition awareness button popup title',
	},
	starPopupDisclaimerWithoutPaymentDetails: {
		id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details',
		defaultMessage:
			'Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.',
		description: 'Edition awareness button popup disclaimer',
	},
	starPopupDisclaimerWithoutPaymentDetailsNoDate: {
		id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date',
		defaultMessage:
			'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
		description:
			'Edition awareness button popup disclaimer for billing admins without payment details when next billing date is unavailable',
	},
	starPopupEndUserDisclaimerWithoutPaymentDetails: {
		id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details',
		defaultMessage:
			'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
		description:
			'Edition awareness button popup disclaimer for end users without payment details when next billing date is unavailable',
	},
	starPopupPrimaryButton: {
		id: 'edition-benefits-modal.edition-benefits-popup.primary-button',
		defaultMessage: 'Explore {edition}',
		description: 'Edition awareness button popup primary button to explore the edition',
	},
	starPopupSecondaryButton: {
		id: 'edition-benefits-modal.edition-benefits-popup.secondary-button',
		defaultMessage: 'Add payment details',
		description: 'Edition awareness button popup secondary button to add payment details',
	},
	starPopupDisclaimerWithPaymentDetails: {
		id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details',
		defaultMessage:
			"You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
		description: 'Edition awareness button popup disclaimer',
	},
	starPopupDisclaimerWithPaymentDetailsNoDate: {
		id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date',
		defaultMessage:
			"You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
		description:
			'Edition awareness button popup disclaimer for billing admins with payment details when next billing date is unavailable',
	},
	starPopupEndUserDisclaimerWithPaymentDetails: {
		id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details',
		defaultMessage: "You won't be charged until your next billing date. <a>See plans</a>.",
		description:
			'Edition awareness button popup disclaimer for end users with payment details when next billing date is unavailable',
	},
});
